export const limits = {
  min: 200,
  max: 1000,
  secs: 1,
};

export enum Product {
  SaaS = 'SaaS',
  Software = 'Software',
}

export const VMS = {
  min: 0,
  max: 1000,
  default: 100,
};

export const CloudInstances = {
  min: 0,
  max: 1000,
  default: 100,
  incrementStep: 100000,
  thresholdToShowEstimate: 2000000,
  months: 12,
};

// UT30 is an unique code to identify each widget in the BPPR ecosystem
export const UT30TurboPE = '30AY5';

export const emailCOSJson = 'turbonomic.json';
